<template src="./ListPayments.html"></template>

<script>
import { getPayments,deletePayment } from "../../../services";
import { OnlyAdmin, OnlyAdminAndAccounting } from '../../../utils/roles'
import { formatDateUTC } from '../../../utils/computeds'
import { mapGetters } from 'vuex'
import Companies from '../../../components/Forms/Companies/Companies'

export default {
  name: "ListPayments",
  components: { Companies },
  data() {
    return {
      payments: [],
      loading: false,
      servicesModal: false,
      selectedPayment: null,
      menuFrom: false,
      menuTo: false,
      skip: 0,
      take: 20,
      disabled: false,
      search: {
        invoiceNumber: '',
        evaluatedDocument: '',
        companyId: null,
        dateFrom: '',
        dateTo: '',
      },
    };
  },
  computed: {
   ...mapGetters({
      user: 'getUser'
    }),
    OnlyAdmin,
    OnlyAdminAndAccounting,
    formatDateUTC,
  },
  created() {
    this.listPayments();
  },
  methods: {
        downloadPdf(url) {
          if (url) {
            window.open(url, '_blank');
          } else {
            this.$notify && this.$notify({ type: 'error', text: 'No hay PDF disponible para este pago.' });
          }
        },
    async listPayments(add) {
      this.loading = true;
      try {
        const params = {
          skip: this.skip,
          take: this.take,
        };
        if (this.search.invoiceNumber) params.invoiceNumber = this.search.invoiceNumber;
        if (this.search.evaluatedDocument) params.evaluatedDocument = this.search.evaluatedDocument;
        if (this.search.companyId) params.companyId = this.search.companyId;
        if (this.search.dateFrom) params.dateFrom = this.search.dateFrom;
        if (this.search.dateTo) params.dateTo = this.search.dateTo;
        const response = await getPayments(params);
        const newItems = response || [];
        if (!add) this.payments = newItems;
        else this.payments.push(...newItems);
        this.disabled = newItems.length < this.take;
      } catch (err) {
        this.payments = [];
        this.$notify && this.$notify({ type: 'error', text: 'Error al cargar los pagos.' });
        console.error('Error loading payments:', err);
      }
      this.loading = false;
    },
    async more() {
      this.skip += this.take;
      await this.listPayments(true);
    },
    async searchPayments() {
      this.skip = 0;
      await this.listPayments();
    },
    showServices(payment) {
      this.selectedPayment = payment;
      this.servicesModal = true;
    },
    capitalize(text) {
      if (!text) return '';
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    formatCurrency(value) {
      if (value == null) return '';
      return `$ ${Number(value).toLocaleString('es-CO')}`;
    },
    ifDeletePayment (paymentId) {
      this.$swal({
        title: '¿Está seguro de eliminar el pago?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((value) => {
        if (value) {
          this.removePayment(paymentId)
        }
      })
    },
      async removePayment (paymentId) {
      try {
        await deletePayment(paymentId)
        this.$swal({
          text: 'Se elimino el pago.',
          buttons: false,
          icon: 'success',
          timer: 3000
        })
        this.searchPayments()
      } catch (error) {
        console.log('Error on delete payment =>', error)
        this.$swal({
          text: error.message ?? 'Ocurrio un error, intenta mas tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    }
  },
};
</script>

<style src="./ListPayments.scss" lang="scss"></style>
